import { atom } from 'recoil';
import { TMainPage } from '@metadata';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

const mainState = atom<TMainPage>({
  key: 'mainState',
  default: {
    loginModal: false, //로그인창 on off 여부
    currentPage: {
      title: '',
      url: '/',
    },
  },
  // effects: [getLocalStorageSession()],
});

export default mainState;
